module.exports = __webpack_public_path__ + "static/media/994.44680cee.png";